import { useState, useEffect } from 'react'

import classnames from 'classnames'
import DismissibleBanner from 'components/DismissibleBanner'
import { InfoButton } from '../../../../../../components/buttons'
import FadeOut from '../../../../../../components/transitions/FadeOut'
import { SignUpBannerTreatmentProps } from './types'

import SignUpBannerCss from './SignUpBanner.styles.scss'

const SignUpBannerControl = ({
  scrolled,
  previouslyDismissed,
  onDismissal,
  onClick,
  onDisplay,
  ctaPath,
}: SignUpBannerTreatmentProps) => {
  const [shown, setIsShown] = useState(false)

  useEffect(() => {
    if (scrolled && !previouslyDismissed) {
      setIsShown(true)
      onDisplay()
    }
  }, [scrolled, previouslyDismissed, onDisplay])

  const closeBanner = () => {
    setIsShown(false)
    onDismissal()
  }

  return (
    <FadeOut
      animateOnEnter
      className={classnames(SignUpBannerCss.root, SignUpBannerCss.sticky)}
      show={shown}
    >
      <DismissibleBanner
        centeredOnMobile
        className={classnames(
          SignUpBannerCss.signUpBannerBg,
          SignUpBannerCss.Control
        )}
        role="banner"
        onClose={closeBanner}
      >
        <div style={{ textAlign: 'center' }}>
          <InfoButton
            pill
            className={SignUpBannerCss.startNewRegButton}
            href={`${ctaPath}?loc=Banner+Button`}
            onClick={() => onClick('Start Your Registry')}
          >
            Start Your Registry
          </InfoButton>
        </div>
      </DismissibleBanner>
    </FadeOut>
  )
}

export default SignUpBannerControl
